import { AnalysisSettings } from 'features/analysis/types'
import { MapDataset } from 'features/maps/types'

export enum BufferType {
  Combined = 'combined',
  NonCombined = 'non-combined'
}

export enum BufferMeasure {
  Meters = 'm',
  Kilometers = 'km'
}

export interface BufferSettings extends AnalysisSettings {
  radius: number
  measure: BufferMeasure
  type: BufferType
  tracts: number
}

export interface BufferSettingsQuery {
  mainSource: MapDataset & { fields; metadata }
  radius: number
  measure: BufferMeasure
  type: BufferType
  tracts: number
  atLocation: string | null
}

export interface BufferSettingsQueryParams {
  radiusInMeters: number
  geomField: string
  columns: Record<string, string>[]
  type: BufferType
  tracts: number
  baseQuery?: string
  atLocation: string | null
}
